export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Edit.vue?vue&type=template&id=18127c38"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Highway/Edit.vue?vue&type=template&id=18127c38
// module id = 2724
// module chunks = 31